import React, { useState } from 'react';
import { ConfigProvider, theme } from 'antd';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../components/dashLayout/DashboardLayout';
import Doctors from '../components/doctors/Doctors';
import Products from '../components/products/Products';
import { logoutLocal } from '../redux/slices/adminSlice';
import { ADMIN_ROUTES } from '../../routes/patientRoutes/routePaths';
import { logoutAdmin } from '../redux/thunks/adminThunks';
import Feedbacks from '../components/feedbacks/Feedbacks';

export default function AdminPage() {
  const [activeKey, setActiveKey] = useState('doctors');
  const dispatch  = useDispatch();
  const navigate  = useNavigate();

  const handleLogout = async () => {
    try {
      await dispatch(logoutAdmin()).unwrap(); // appelle l'API + reset Redux
    } catch (_) {
      // même si erreur, on force la navigation
    } finally {
      navigate(ADMIN_ROUTES.LOGIN, { replace: true });
    }
  };

  return (
    <ConfigProvider
      theme={{
        algorithm: theme.defaultAlgorithm,
        token: { colorPrimary: '#3B82F6', borderRadius: 10 },
      }}
    >
      <DashboardLayout
        activeKey={activeKey}
        onChange={setActiveKey}
        onLogout={handleLogout}
      >
        {activeKey === 'doctors' && <Doctors />}
        {activeKey === 'products' && <Products />}
        {activeKey === 'feedbacks' && <Feedbacks />}
      </DashboardLayout>
    </ConfigProvider>
  );
}




